import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { routePaths } from '@config/routes'
import { AppShell } from '@app/layouts/AppShell'
import { LoginShell } from '@app/layouts/LoginShell'
import { PageLoader } from './routes/PageLoader'
import { ProtectedPage } from './routes/ProtectedPage'
import { ProtectedRoute } from './routes/ProtectedRoute'
import { appFeatureRoutes, LoginPageLazy } from './routes/routeRegistry'

export function AppRouter() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route
          path={routePaths.login}
          element={
            <LoginShell>
              <LoginPageLazy />
            </LoginShell>
          }
        />

        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          
          {appFeatureRoutes.map(({ path, requireCompany, Page }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedPage requireCompany={requireCompany}>
                  <Page />
                </ProtectedPage>
              }
            />
          ))}
        </Route>

        <Route path="*" element={<Navigate to={routePaths.login} replace />} />
      </Routes>
    </Suspense>
  )
}
